import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  isOrderEnabled,
  getLocalizedDescription,
  getLocalizedName,
  isAdminMode as _isAdminMode,
  getCallWaiterOrAdditionPrice,
  getCallWaiterPriceWithPreSelections,
  getAvailableItemAdditionGroups,
  replaceColorInLottie,
} from '../../../../utility/util/util.service';

import LazyImage from '../../lazyload/lazy-image/lazy-image.component';
import classnames from 'classnames';
import ModalSheet from '../modal-sheet/modal-sheet.component';
import { connect } from 'react-redux';
import {
  setIsCallWaiterModalOpen,
  // setCallWaiterModalData,
} from '../../../../redux/modal/modal.actions';
import { addCartItem } from '../../../../redux/store/store.actions';
import { Button } from 'reactstrap';
import { SocketContext } from '../../../../context/socket.context';
import {
  basePostQuery,
  createGuest,
} from '../../../../utility/sb-api/sb-api.service';
import { fetchOnAuthenticated } from '../../../../redux/me/me.actions';
import xss from 'xss';
import TagManager from 'react-gtm-module/dist/TagManager';
import CategoryBreadCrumbs from '../../helpers/CategoryBreadCrumbs';
import { useLocation } from 'react-router';
import { SwipeableButton } from 'react-swipeable-button';
import {
  customMessageNotification,
  notification,
} from '../../../../utility/notification/notification.service';
import Lottie from 'lottie-react';
import success3 from '../../../../assets/lottie/success-3.json';

const CallWaiterInfoModal = ({
  isOpen,
  me,
  store,
  table,
  setIsCallWaiterModalOpen,
}) => {
  const intl = useIntl();
  const closeModal = () => {
    setIsWaiterCalled(false);
    setIsCallWaiterModalOpen(false);
  };
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isWaiterCalled, setIsWaiterCalled] = useState(false);
  const swipeableButtonRef = useRef(null);

  const handleReset = () => {
    swipeableButtonRef.current && swipeableButtonRef.current.buttonReset(); // Call the reset method
  };

  const handleCallWaiter = () => {
    setIsSubmitting(true);
    basePostQuery(
      `stores/${store?.id}/call-a-waiter`,
      null,
      null,
      null,
      null,
      true,
    )
      .then(() => {
        handleReset();
        setIsWaiterCalled(true);
        setIsSubmitting(false);
        customMessageNotification(
          'success',
          intl.formatMessage(
            { id: 'callWaiterNotificationSuccess' },
            { storeName: store?.name, tableNumber: table?.name },
          ),
        );
      })
      .catch(() => {
        customMessageNotification(
          'error',
          intl.formatMessage({ id: 'callWaiterNotificationError' }),
        );
        handleReset();
        setIsSubmitting(false);
      });
  };
  const successAnimationFull = useMemo(
    () => (
      <Lottie
        className="m-auto"
        style={{ width: '100%', maxWidth: '250px' }}
        animationData={replaceColorInLottie(
          success3,
          store?.primaryColor || '#22442c',
        )}
        onComplete={() => {
          setIsSubmitting(true);
          //setAnimationFinished(true);
          setTimeout(() => {
            setIsSubmitting(false);
            closeModal();
          }, 1000);
        }}
        loop={false}
      />
    ),
    [store?.primaryColor],
  );
  return (
    <ModalSheet
      isOpen={isOpen}
      closeModal={closeModal}
      //title={intl.formatMessage({ id: 'callWaiterTitle' })}
    >
      <div className="p-1 text-center">
        {isWaiterCalled ? (
          successAnimationFull
        ) : (
          <>
            <span className="font-weight-bolder font-medium-2 text-dark">
              <FormattedMessage id="callWaiterTitle" />
            </span>
            <p className="my-1">
              <FormattedMessage
                id="callWaiterText"
                values={{ storeName: store?.name, tableNumber: table?.name }}
              />
            </p>
            <div
              style={{ touchAction: 'pan-y' }}
              className="d-flex bg-white mt-1 justify-content-center"
            >
              <SwipeableButton
                text_unlocked={intl.formatMessage({ id: 'loading' })}
                ref={swipeableButtonRef}
                onSuccess={handleCallWaiter}
                circle
                text={intl.formatMessage(
                  { id: 'callWaiterSwipeLabel' },
                  { storeName: store?.name },
                )}
                disable={isSubmitting}
              />
            </div>
          </>
        )}
      </div>
    </ModalSheet>
  );
};

const mapStateToProps = (state) => ({
  isOpen: state.modals.isCallWaiterModalOpen,
  store: state.store.store,
  me: state.me.me,
  table: state.store.table,
});

export default connect(mapStateToProps, {
  // setCallWaiterModalData,
  setIsCallWaiterModalOpen,
})(CallWaiterInfoModal);
